import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import your translation files
import { enTranslations } from "./en.ts";
import { viTranslations } from "./vi.ts";

const resources = {
  en: {
    translation: enTranslations,
  },
  vi: {
    translation: viTranslations,
  },
};

// Get saved language from localStorage or default to 'vi'
const savedLanguage = localStorage.getItem("i18nextLng") || "vi";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: "vi",
  debug: process.env.NODE_ENV === "development",

  interpolation: {
    escapeValue: false, // React already does escaping
  },

  // Namespace configuration
  defaultNS: "translation",
  ns: ["translation"],

  // Language detection (not needed but kept for reference)
  detection: {
    order: ["localStorage", "navigator", "htmlTag"],
    caches: ["localStorage"],
    lookupLocalStorage: "i18nextLng",
  },
});

export default i18n;
